import { render, staticRenderFns } from "./FlexContainer.vue?vue&type=template&id=7423907e&"
import script from "./FlexContainer.vue?vue&type=script&lang=js&"
export * from "./FlexContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports